// extracted by mini-css-extract-plugin
export default {"PuzzleScene":"PuzzleDetailsScene_PuzzleScene__9bCyP","HeaderLabel":"PuzzleDetailsScene_HeaderLabel__-kPee","RelativePosition":"PuzzleDetailsScene_RelativePosition__5a-Wl"};